import type { PropertySearchQuery } from './useSearchQueries';

interface MarketplacePageKeyOptions {
  initialVariables: unknown;
  queryParams: PropertySearchQuery;
  savedSearchId: string | null;
}

export const buildMarketplacePageKey = ({
  initialVariables,
  queryParams,
  savedSearchId,
}: MarketplacePageKeyOptions): string =>
  JSON.stringify({
    initialVariables,
    queryParams: { ...queryParams, preview_aid: undefined },
    savedSearchId,
  });
